{
  "validations": {
    "required": "Detta fält är obligatoriskt",
    "email": "Ogiltig e-postadress",
    "workflow": {
      "rejectCommentRequired": "Kommentar är obligatorisk för avvisning"
    },
    "contributorOwnerMustBeInCategory": "Ägare med rollen redigerare måste vara i samma kategori som dokumentet",
    "contributorPublisherMustBeInCategory": "Utgivare med rollen redigerare måste vara i samma kategori som dokumentet",
    "endDateAfter": "Slutdatum måste vara efter startdatum",
    "allStepsMustHaveAName": "Alla steg måste ha ett namn",
    "workflowDatesMustFollowPrevious": "Varje datum i arbetsflödet måste vara samma som eller efter det föregående"
  }
}
